import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  knowledgeInsightPostId: string;
};

type MessageWithIdType = ResponseMessageType & {
  id: string;
};

const request = ({ knowledgeInsightPostId }: RequestDataType) => {
  return new ApiClient()
    .post<MessageWithIdType>(
      `/api/members/knowledge_insight_posts/${knowledgeInsightPostId}/bookmarks`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKnowledgeInsightPostsBookmarksCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<MessageWithIdType, RequestDataType> => {
  return useMutation(request, { ...options });
};
